<template>
	<div class="margin-left-sm">
		<div class="flex">
			<div class="money-my">
				<p class="text-left padding-tb-sm solid-bottom padding-lr-sm text-lg">我的钱包</p>
				<div class="flex padding-tb-sm">
					<div class="flex-sub withdrawable">
						<p class="fs28 text-theme">￥{{price}}</p>
						<p class="text-sm text-666 margin-top-xs">账户收入可提现金额</p>
					</div>
					<div class="flex-sub">
						<p class="fs28 text-theme">￥{{frozen_price}}</p>
						<p class="text-sm text-666 margin-top-xs">申请提现冻结金额</p>
					</div>
				</div>
			</div>
			<div class="operation margin-left-sm">
				<el-row :gutter="0">
					<el-col :span="12">
						<div class="flex pointer solid-bottom solid-right height93 align-center justify-center" @click="godetail('withdraw')">
							<img class="shen-min margin-right-sm" src="../../../assets/img/wallet/shen-min.png" >
							<p class="text-sm">立即申请提现</p>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="flex pointer solid-bottom height93 align-center justify-center" @click="godetail('setpass')">
							<img class="setpass margin-right-sm" src="../../../assets/img/wallet/setpass.png" >
							<p class="text-sm">设置提现密码</p>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="flex pointer height93 solid-right align-center justify-center" @click="godetail('withdrawrecord')">
							<img class="red-money margin-right-sm" src="../../../assets/img/wallet/red-money.png" >
							<p class="text-sm">申请提现记录</p>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="flex pointer height93 align-center justify-center" @click="godetail('income')">
							<img class="shou-red margin-right-sm" src="../../../assets/img/wallet/shou-red.png" >
							<p class="text-sm">课程收入明细</p>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		
		<div class="margin-top ">
			<div class="flex align-center justify-between margin-bottom-sm" @click="godetail('bank')">
				<p class="fs22">银行卡</p>
				<p class="text-sm pointer flex align-center"> <span>我的银行卡</span> <i class="el-icon-arrow-right text-theme fs22 text-bold"></i></p>
			</div>
			<div class="flex bg-white align-center justify-between default padding-lr">
				<div class="align-center flex" v-if="bank">
					<p class="text-999 text-df">当前默认银行卡</p>
					<div class="flex align-center">
						<img class="bindcard" src="../../../assets/img/wallet/bindcard.png" >
						<p class="text-df">{{bank.name}}</p>
					</div>
				</div>
				<div class="flex align-center pointer" @click="godetail('addbank')">
					<i class="el-icon-circle-plus-outline fs28 text-theme"></i>
					<p class="text-theme text-sm">添加银行卡</p>
				</div>
			</div>
		</div>
		
		<div class="margin-top">
			<div class="flex align-center justify-between margin-bottom-sm">
				<p class="fs22">最新收入</p>
				<p @click="godetail('income')" class="text-sm flex pointer align-center"> <span>全部</span> <i class="el-icon-arrow-right text-theme fs22 text-bold"></i></p>
			</div>
			<div>
				<div v-for="(item,index) in list" :key="index" class="flex align-center justify-between bg-white record padding-lr margin-bottom-sm">
					<div class="text-df">{{item.des}}</div>
					<div class="align-center flex">
						<p class="text-sm text-999 margin-right">{{item.create_time}}</p>
						<p class="text-df text-theme text-bold">+{{item.price}}</p>
					</div>
				</div>
				<div class="text-center" v-if="list.length == 0">
					<el-empty description="暂无数据"></el-empty>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				price:0,//账户收入可提现金额
				frozen_price:0,//申请提现冻结金额
				bank:null,
				list:[],
				isset:false
			};
		},
		created() {
			this.getMyMoney()
			this.getBankList()
			this.getHomePriceList()
			this.getisPricePwd()
		},
		methods: {
			//通知center 跳转对应页面
			godetail(index){
				let type = {
					type:index,
					typeone:'wallet'
				}
				this.$emit('gettype',type)
			},
			getMyMoney(){
				this.ajax('get', '/api/pc/priceLog/getMyPrice',{
					
				}, res => {
					if (res.status == 200) {
						this.price = res.data.price
						this.frozen_price = res.data.frozen_price
					} else {
						this.$message(res.msg);
					}
				})
			},
			/* *
			 * 获取我的默认银行卡
			 * */
			getBankList(){
				this.ajax('get', '/api/pc/userBank/getMorenBank',{}, res => {
					if (res.status == 200) {
						this.bank = {
							name:res.data.bank,
							bank_number:res.data.bank_number
						}
					} else {
						this.$message(res.msg);
					}
				})
			},
			/* *
			 * 展示4条记录
			 * */
			getHomePriceList(){
				this.ajax('get', '/api/pc/priceLog/getHomePriceList',{}, res => {
					if (res.status == 200) {
						this.list = res.data.data
					} else {
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 判断是否有提现密码
			 * */
			getisPricePwd(){
				this.ajax('get', '/api/pc/user/isPricePwd',{}, res => {
					if (res.status == 200) {
						if(res.data.code == 250){
							this.isset = false
						}else{
							this.isset = true
						}
					} else {
						this.$message(res.msg);
					}
				})
				
			}
		}
	}
</script>

<style scoped lang="less">
	.fs28{
		font-size: 28px;
	}
	.fs24{
		font-size: 24px;
	}
	.fs22{
		font-size: 22px;
	}
	.shen-min{
		width: 24px;
		height: 26px;
	}
	.setpass{
		width: 28px;
		height: 27px;
	}
	.red-money{
		width: 28px;
		height: 28px;
	}
	.shou-red{
		width: 27px;
		height: 27px;
	}
	.money-my{
		width: 425px;
		// height: 189px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 8px;
	}
	.withdrawable{
		position: relative;
		&::after{
			position: absolute;
			top: 50%;
			right: 0;
			width: 1px;
			height: 80px;
			background: #F2F0F0;
			content: '';
			transform: translateY(-50%);
		}
	}
	.operation{
		width: 471px;
		height: 187px;
		background: #FFFFFF;
		box-shadow: 0px 2px 51px 0px rgba(34,34,34,0.08);
		border-radius: 8px;
	}
	.height93{
		height: 93px;
	}
	.default{
		height: 80px;
		box-shadow: 0px 2px 51px 0px rgba(34,34,34,0.08);
		border-radius: 8px;
	}
	.bindcard{
		width: 32px;
		height: 21px;
		margin-left: 100px;
	}
	.record{
		height: 58px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/wallet/index.vue